<template>
    <div>
        <h1 class="title">Créer un compte</h1>
        <div class="card white">
            <h2>Détails du compte</h2>
            <div class="form-group">
                <div class="form-control">
                    <label for="email">Email*</label>
                    <input type="email" id="email" v-model="email" required />
                </div>
                <div class="form-control agency">
                    <label class="info-label" for="agency">Agence*</label>
                    <input type="text" id="agency" v-model="searchAgency" @input="searchAgencies" autocomplete="off"
                        required />
                    <div v-if="searchAgency.length > 0" class="info-message">Sélectionnez une agence dans la liste des
                        propositions.</div>
                    <ul v-if="agencyOptions.length" class="address-options">
                        <li v-for="option in agencyOptions" :key="option.id" @click="selectAgency(option)">{{
                            option.name }}</li>
                    </ul>
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label>Est-il responsable d'agence ?</label>
                    <input type="checkbox" id="proprietaire" v-model="proprietaire" style="display: none;" />
                    <label
                        :class="{ 'button': true, 'outline': !proprietaire, 'fill': proprietaire, 'dotted': true, 'orange': true }"
                        for="proprietaire" style="transition: none;">
                        {{ proprietaire ? "Oui" : "Non" }}
                    </label>
                </div>
                <div class="form-control">
                    <label>Notifier ?</label>
                    <input type="checkbox" id="notification" v-model="notification" style="display: none;" />
                    <label
                        :class="{ 'button': true, 'outline': !notification, 'fill': notification, 'dotted': true, 'orange': true }"
                        for="notification" style="transition: none;">
                        {{ notification ? "Oui" : "Non" }}
                    </label>
                </div>
            </div>
            <div v-if="errorMessage" class="message">{{ errorMessage }}</div>
            <button type="submit" class="button fill normal" :disabled="isSubmitting" @click="submitForm">
                Ajouter
            </button>
        </div>
    </div>
</template>


<script>

export default {
    name: 'AjouterCompte',
    data() {
        return {
            email: "",
            isSubmitting: false,
            agencies: [],
            agency: "",
            searchAgency: "",
            agencyOptions: [],
            proprietaire: true,
            notification: false,
            errorMessage: "",
        };
    },
    created() {
        this.fetchAllAgencies();
    },
    methods: {
        searchAgencies() {
            if (this.searchAgency.length < 3) return this.agencyOptions = [];
            this.agencyOptions = this.agencies.filter(agency => agency.name.toLowerCase().includes(this.searchAgency.toLowerCase()));
        },
        selectAgency(option) {
            this.searchAgency = option.name;
            this.agency = option.ID;
            this.agencyOptions = [];
        },
        async fetchAllAgencies() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + "admin/agencies", { method: "GET", credentials: "include", });
                const data = await response.json();

                if (data.error) return window.location.href = "/login";

                this.agencies = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            } catch (error) {
                this.errorMessage = "Une erreur est survenue.";
            }
        },
        async submitForm() {
            if (!this.email) return this.errorMessage = " Veuillez saisir une adresse email valide.";
            if (!this.agency) return this.errorMessage = " Veuillez saisir une agence.";

            try {
                this.isSubmitting = true;
                this.errorMessage = "";

                const body = JSON.stringify({ email: this.email, agency: this.agency, proprietaire: this.proprietaire, notification: this.notification });
                const response = await fetch(process.env.VUE_APP_API_URL + "admin/franchise/add", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: 'include', body, });

                if (response.ok) return window.location.reload();

                const errorData = await response.json();
                this.errorMessage = errorData.message || "Erreur lors de la soumission des données. Veuillez réessayer.";
            } catch (error) {
                console.error("Erreur lors de la soumission du formulaire:", error);
                this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
            } finally {
                this.isSubmitting = false;
            }
        },
    },
}
</script>

<style>
.form-control.agency {
    position: relative;
}
</style>